import { Component } from 'react'

import * as h from 'h'

import { projectSortOptions } from 'config'

import styles from './styles-advanced-filters.scss'

export default class Sort extends Component {
  render () {
    const { label, value, onChange } = this.props

    return h.div(h.ca(styles.sortFilter),
      h.div(null,
        h.maybe(label, h.span(null, label)),
        h.select({
          value,
          onChange: e => onChange(e.target.value),
          name: 'select sorting-method'
        },
          projectSortOptions.map(([ value, display ]) =>
            h.option({ key: value, value }, display)))))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Explore/Sort.js